import { all, takeEvery, put, call } from "redux-saga/effects";
import axiosMain from "../../../http/axios/axios_main";
import * as actionTypes from "../../actionLabels";
import * as actionsBidHistory from "../../actions";
import CustomToast from "../../../components/Toast";

export function* fetchBuyerOutstandingPaymentDetailData(action) {
  console.log('action calls', action);

  try {
    yield put(actionsBidHistory.fetchBuyerOutsPaymtDetailDataApiCall(true));

    const response = yield call(
      axiosMain.post,
      '/postauction/Report/buyerOutstandingPaymentReport',
      action.payload
    );

    if (response.status === 200) {
      if (response.data.statusCode === 200) {
        console.log('line 17', response);
        if (action.payload.isExport === 1 || action.payload.isExport === 2) {
          yield put(
            actionsBidHistory.fetchBuyerOutsPaymtDetailDataExportSuccess(response.data)
          );
        } else {
          yield put(
            actionsBidHistory.fetchBuyerOutsPaymtDetailDataSuccess(response.data)
          );
        }
      } else {
        CustomToast.error(response.data.message);
        yield put(
          actionsBidHistory.fetchBuyerOutsPaymtDetailDataSuccess(response.data)
        );
      }
    } else {
      CustomToast.error(response.data.message);
      yield put(
        actionsBidHistory.fetchBuyerOutsPaymtDetailDataFailure(response.data.message)
      );
    }
  } catch (error) {
    yield put(actionsBidHistory.fetchBuyerOutsPaymtDetailDataFailure(error));
  } finally {
    yield put(actionsBidHistory.fetchBuyerOutsPaymtDetailDataApiCall(false));
  }
}

export function* buyerOutstandingPaymentDetailReportSagas() {
  yield takeEvery(
    actionTypes.FETCH_BUYER_OUTS_PAYMT_DETAIL_DATA,
    fetchBuyerOutstandingPaymentDetailData
  );
}
